// odigeo, utils, polyfills
require('./odigeo');
require('./odigeo.pollyfills');
require('./odigeo.utils');
require('./odigeo.utils.advertisement');
require('./odigeo.utils.cookies');
require('./odigeo.utils.currency');
require('./odigeo.utils.weight');
require('./odigeo.overrideErrorHandlers');

// jQuery libs
require('../../thirdParty/jquery/jquery.event.move.min');
require('../../thirdParty/jquery/jquery.event.swipe.min');
require('../../thirdParty/jquery/jquery.tap.min');
require('../../thirdParty/jquery/jquery.animate-enhanced.min');
require('../../thirdParty/jquery/jquery.animate-enhanced.promise.min');
require('../../thirdParty/jquery/jquery.placeholder.min');
require('../../thirdParty/jquery/jquery.dateentry.min');

// ui
require('./odigeo.ui');
require('./odigeo.ui.advertisement');
require('./odigeo.ui.alerts');
require('./odigeo.ui.autocomplete');
require('./odigeo.ui.backgroundTab');
require('./odigeo.ui.bubbleNotification');
require('./odigeo.ui.button');
require('./odigeo.ui.calendar');
require('./odigeo.ui.carousel');
require('./odigeo.ui.checkboxRadio');
require('./odigeo.ui.collapsive');
require('./odigeo.ui.conditionsPopup');
require('./odigeo.ui.datepicker');
require('./odigeo.ui.datepickerwithselects');
require('./odigeo.ui.dialogs');
require('./odigeo.ui.dialogsByTemplate');
require('./odigeo.ui.drawArrow');
require('./odigeo.ui.expandable');
require('./odigeo.ui.fade');
require('./odigeo.ui.hint');
require('./odigeo.ui.histogram');
require('./odigeo.ui.inputDate');
require('./odigeo.ui.lightbox');
require('./odigeo.ui.loading');
require('./odigeo.ui.menu');
require('./odigeo.ui.numbersCounter');
require('./odigeo.ui.pagination');
require('./odigeo.ui.radioGroup');
require('./odigeo.ui.range');
require('./odigeo.ui.spinner');
require('./odigeo.ui.switcher');
require('./odigeo.ui.tabs');
require('./odigeo.ui.textRotator');
require('./odigeo.ui.tooltip');
require('./odigeo.ui.shake');

module.exports = Odigeo;
